<form [formGroup]="filterForm">
  <select formControlName="value" class="form-control min-width" (change)="onChange()" aria-label="Filter table multiple select">
    <option value="" selected="selected">{{ filter.getMultipleSelectionFilterTemplate().labelFastFilter | translate }}</option>
    <option *ngFor="let option of filter.getMultipleSelectionFilterTemplate().options" [ngValue]="option.value">{{ option.label | translate }}</option>
  </select>
</form>
